import request from '@/utils/request'


export function getAddr(params) {
  return request({
    url: '/static/map/getAddr',
    method: 'get',
    params: params
  })
}




// WEBPACK FOOTER //
// ./src/api/mapqq.js